import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const MetaUpdater = () => {
  const { i18n } = useTranslation();

  const isDutch = i18n.language.startsWith('nl');

  const title = isDutch 
    ? 'Puritybase | Koop Retatrutide, GHK-Cu, BPC-157 & TB-500'
    : 'Puritybase UK | Puritybase';

  const description = isDutch
    ? 'Koop hoogwaardige peptides zoals Retatrutide, GHK-Cu, BPC-157 & TB-500 – veilig en discreet geleverd binnen 24 uur.'
    : 'High-quality peptides like Retatrutide, GHK-Cu, BPC-157 & TB-500 – safely and discreetly delivered within 24 hours.';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default MetaUpdater;
